import { Team, TeamMember } from '@demind-inc/core';
import { useQuery } from '@tanstack/react-query';

import { teamApi } from '../api';

interface UseTeamsParams {
  userId: string;
}

export interface TeamListItem {
  team: Team;
  membership: TeamMember;
}

export interface TeamListResult {
  teams: TeamListItem[];
}

export const TEAM_LIST_QUERY_KEY = ['lifestack.team.list'];

export const useTeams = ({ userId }: UseTeamsParams) => {
  const teamsQuery = useQuery({
    queryKey: ['lifestack.team.list', { userId }],
    queryFn: () => {
      return teamApi.getTeams().then(({ data }) => {
        const teams = (data.teams ?? []) as TeamListItem[];

        return {
          teams,
        };
      });
    },
    refetchOnWindowFocus: false,
    enabled: !!userId,
    staleTime: 5000,
  });

  const teams = (teamsQuery.data?.teams ?? []) as TeamListItem[];

  return {
    teams,
    activeTeam: teams[0]?.team ?? null,
    activeMembership: teams[0]?.membership ?? null,
    ...teamsQuery,
  };
};
